import React, { useState } from "react";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import { InputAdornment } from "@mui/material";
// import "./style.css";
import { useDebouncedCallback } from "use-debounce";
import styleSheet from "./style.module.scss";
import SyIcon from "../../components/sy-icon";

type Props = {
  options: any;
  type?: "dark" | "light";
  placeholder?: any;
  enableSearchBox?: boolean;
  limitItems?: number;
  loading?: boolean | "nodata";
  multiple?: boolean;
  image?:any;
  defaultvalue?: any;
  onFocus?: () => void;
  value?: any;
  handleFilter?: (val: any) => void | null;
  handleChange: (val: any) => void | null;
  getoptlabel: (val: any) => string;
  style?: any;
  clearIcon?: any;
  onBlur?: (val: any) => void | null;
  getIcon?: any;
  popupIcon?: boolean;
  errorMessage?: any;
  disabled?: boolean;
};

const defaultProps: Props = {
  options: [],
  getIcon: () => null,
  placeholder: "placeholder",
  multiple: false,
  enableSearchBox: false,
  loading: false,
  defaultvalue: null,
  image:null,
  disabled: false,
  type: "dark",
  handleFilter: () => {
    return void 0;
  },
  handleChange: () => {
    return void 0;
  },
  getoptlabel: () => {
    return "";
  },
};

const SyDropdown = React.forwardRef<HTMLInputElement, Props>(
  (props: Props, ref) => {
    const {
      options,
      placeholder,
      enableSearchBox,
      loading,
      multiple,
      type,
      defaultvalue,
      disabled,
      onFocus,
      image,
      value,
      handleChange,
      handleFilter,
      getoptlabel,
      limitItems,
      popupIcon = true,
      style = { width: "100%", height: "100%" },
      clearIcon = false,
      onBlur,
      getIcon,
      errorMessage,
      ...rest
    } = props;

    const handleNoOptionText = "no_data_found";
    const [focused, setFocused] = useState(false);
    const debouncedHandleInputChange = useDebouncedCallback(
      (event: any, newValue: any) => {
        if (typeof handleFilter === "function") {
          handleFilter(newValue);
        }
      },
      800
    );

    const handleInputChange = (event: any, newValue: any) => {
      debouncedHandleInputChange(event, newValue);
    };

    const getOptionLabel = (opt: any) => {
      return getoptlabel(opt);
    };

    const handleOnChange = (event: any, value: any) => {
      handleChange(value);
    };

    const handleOptionRender = (props: any, option: any) => {
      console.log(option,'option')
      return (
        <li
          {...props}
          key={props.id}
          style={{
            borderBottom: "2px solid",
            borderColor: "rgba(255, 255, 255, 0.05)",
            display: "flex",
            alignItems: "center",
            gap: "8px",
          }}
        >
          {/* Example: render image from option.image */}
          
          
             {getImage(option)}
          {getIcon(option)}
          {getoptlabel(option)}
        </li>
      );
    };
    
    const getImage =(option:any)=>{

      return(
        image?(
          <img
          src={option[image]}
          alt={getoptlabel(option)}
          style={{ width: 24, height: 24,  }}
        />
        ):null
      )

    }

    const optEqualtoVal = (option: any, value: any) => {
      return getoptlabel(option) === getoptlabel(value);
    };

    const dropDownIcon = (
      <SyIcon
        name={"expand_more"}
        iconColor={
          type === "light" ? "rgb(163, 163, 163)" : "rgba(255, 255, 255, 0.3)"
        }
        className={" top-25 end-0"}
      />
    );

    const renderenableSearchBox = (params: any) => {
      return (
        <TextField
          {...params}
          size="small"
          className={styleSheet.formStyle}
          // InputProps={{
          //   ...params.InputProps,
          //   disableAnimation: true,

          //   // onKeyDown: (e) => {
          //   //   if (e.key === 'Enter') {
          //   //     e.stopPropagation();
          //   //   }
          //   // },
          //   endAdornment: (
          //     <InputAdornment position="end">
          //       {/* <SyIcons name="search" iconStyle="round" className={"position-absolute top-25 end-0"}/> */}
          //     </InputAdornment>
          //   ),
          // }}
          label={focused || value ? "" : placeholder}
          onFocus={() => setFocused(true)}
          onBlur={() => setFocused(false)}
        />
      );
    };

    const styleLight = {
      "& .MuiOutlinedInput-root": {
        "&.Mui-focused fieldset": {
          borderColor: "rgb(163, 163, 163)",
        },
        "&.MuiInputBase-root fieldset": {
          borderColor: "rgb(163, 163, 163)",
          border: "2px solid",
        },
      },
    };
    const styleDark = {
      "& .MuiOutlinedInput-root": {
        "&.Mui-focused fieldset": {
          borderColor: "rgb(163, 163, 163)",
        },
        "&.MuiInputBase-root fieldset": {
          border: "none",
        },
      },
    };

    const renderDropdown = (params: any) => {
      return (
        <TextField
          // className={styleSheet.formStyle}
          {...params}
          size="small"
          label={focused || value ? "" : placeholder}
          onFocus={() => setFocused(true)}
          onBlur={() => setFocused(false)}
          InputLabelProps={{
            className: `${
              type === "light" ? styleSheet.lable_light : styleSheet.lable
            } `,
          }}
          sx={type === "light" ? styleLight : styleDark}
        />
      );
    };

    const handleInputRender = enableSearchBox
      ? renderenableSearchBox
      : renderDropdown;

    const Value = defaultvalue ? defaultvalue : multiple ? [] : null;

    const handleLoading = loading === "nodata" ? true : loading;
    const handleLoadingText =
      loading === "nodata" ? "no_data_found" : "loading" + "...";

    return (
      <>
        <Autocomplete
          ref={ref}
          id="mui-autocomplete"
          onFocus={onFocus}
          clearOnBlur
          selectOnFocus
          handleHomeEndKeys
          limitTags={limitItems}
          filterSelectedOptions
          disableCloseOnSelect={multiple}
          options={options}
          defaultValue={defaultvalue}
          value={value}
          forcePopupIcon={popupIcon}
          // freeSolo={enableSearchBox}
          multiple={multiple}
          loading={handleLoading}
          loadingText={handleLoadingText}
          popupIcon={dropDownIcon}
          noOptionsText={handleNoOptionText}
          onChange={handleOnChange}
          onInputChange={handleInputChange}
          renderOption={handleOptionRender}
          renderInput={handleInputRender}
          getOptionLabel={getOptionLabel}
          isOptionEqualToValue={optEqualtoVal}
          disablePortal
          // sx={{ ...style }}
          sx={{
            "& .MuiAutocomplete-inputRoot": {
              backgroundColor:
                type === "light"
                  ? "rgba(255, 255, 255)"
                  : "rgba(255, 255, 255, 0.1)",
              color:
                type === "light"
                  ? "rgb(163, 163, 163)"
                  : "rgba(255, 255, 255, 0.8)",
              fontFamily: "Mohave, sans-serif",
              fontOpticalSizing: "auto",
              fontWeight: "300",
              fontStyle: "normal",
              borderRadius: "8px",
              padding: "0",
            },

            "& + .MuiAutocomplete-popper .MuiAutocomplete-listbox": {
              backgroundColor: type === "light" ? "white" : "#443D4A",
              color:
                type === "light"
                  ? "rgb(163, 163, 163)"
                  : "rgba(255, 255, 255, 0.5)",
              fontFamily: "Mohave, sans-serif",
              fontOpticalSizing: "auto",
              fontWeight: "300",
              fontFStyle: "normal",
              

            },
          }}
          disableClearable={clearIcon}
          disabled={disabled}
          onBlur={onBlur}
          {...rest}
        />
        {errorMessage ? (
          <span className="d-flex justify-content-end">
            {/* <Errormessage message={errorMessage} /> */}
          </span>
        ) : (
          void null
        )}
      </>
    );
  }
);

SyDropdown.defaultProps = defaultProps;

export default SyDropdown;
